<div class="p500-ui-form-field">
  @if (label) {
  <span class="p500-ui-form-field__label">{{ label }}</span>
  }
  <quill-editor [formControl]="control" (ngModelChange)="updateValue($event)" [ngClass]="customClass" [placeholder]="placeholder">
  </quill-editor>
</div>
